module.exports = __webpack_public_path__ + "static/cubes_right-d3b0ea222138260d4d04b1318ed5ff5e.png";